import { View, Text, StyleSheet, Image, ViewStyle } from "react-native";
import { Colors, Typography } from "../../styles";
import { PieChart } from "react-native-chart-kit";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/mainSlice";

const Key = ({
  data,
}: {
  data: { name: string; percentage: number; color: string }[];
}) => {
  const user = useSelector(selectUser);

  return (
    <View style={styles.key}>
      {data.map((d) => (
        <View style={[styles.keyItem]}>
          <View style={[styles.row, styles.keyLeft]}>
            <View style={[styles.keyIcon, { backgroundColor: d.color }]} />
            <Text style={[Typography.paragraph, styles.keyText]}>{d.name}</Text>
          </View>

          <Text style={[Typography.paragraph, { opacity: 0.5 }]}>
            {d.percentage}%
          </Text>
        </View>
      ))}
    </View>
  );
};

const DataSources = ({ style }: { style?: ViewStyle }) => {
  const user = useSelector(selectUser);

  const data = [
    {
      name: "Open Source Intel",
      percentage: 20,
      color: Colors.teal300,
    },
    {
      name: `${user.name}'s iPhone`,
      percentage: 30,
      color: Colors.coral300,
    },
    {
      name: "Connected APIs",
      percentage: 15,
      color: Colors.blue300,
    },
    {
      name: `${user.name}'s Macbook Pro`,
      percentage: 35,
      color: Colors.yellow300,
    },
  ];

  return (
    <View style={[styles.row, style]}>
      {/* Profile icon */}
      <View style={styles.profileIcon}>
        <PieChart
          backgroundColor={Colors.plum900}
          data={data}
          width={100 * 1.25}
          height={100 * 1.25}
          chartConfig={{
            color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
            labelColor: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
          }}
          accessor={"percentage"}
          center={[(100 * 1.25) / 4, 0]}
          hasLegend={false}
        />
        <Image
          source={{
            uri: user.image,
          }}
          style={styles.profileImage}
          resizeMode="cover"
        />
      </View>
      <Key data={data} />
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  profileIcon: {
    width: 100,
    height: 100,
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    marginRight: 10,
  },
  profileImage: {
    height: "90%",
    width: "90%",
    borderRadius: 200,
    position: "absolute",
  },
  key: {
    flex: 1,
    maxWidth: 220,
  },
  keyItem: {
    marginBottom: 10,
    // width: "100%",
    flexDirection: "row",
  },
  keyLeft: {
    flex: 1,
    marginRight: 10,
    justifyContent: "flex-start",
  },
  keyIcon: {
    width: 15,
    height: 15,
    borderRadius: 5,
    marginRight: 5,
  },
  keyText: {
    fontSize: 13,
  },
});

export default DataSources;
